// @ts-check
import classNames from 'classnames';
import { graphql } from 'gatsby';
import React from 'react';
import Link from '~/components/Common/Link';
import MiniSpinner from './MiniSpinner';

import './LinkButton.scss';

export const query = graphql`
	fragment ButtonFragment on Ozk_content_blockModular_blocksCopyContent {
		button {
			button_text
			button_id
			button_link
			open_in_new_tab
			button_style
			button_features
		}
	}
`;

/**
 * @typedef ButtonOption
 * @property {('arrow' | 'full-width' | 'italic' | 'upper')[]} [button_features=[]]
 * @property {string} button_link
 * @property {string} [button_id]
 * @property {'primary' | 'secondary' | 'tertiary'} [button_style]
 * @property {string} [button_text]
 * @property {boolean} open_in_new_tab
**/
/**
 * @typedef LinkButtonOptions
 * @property {string} [className]
 * @property {boolean} [isDisabled=false]
 * @property {boolean} [isLoading=false]
 * @property {boolean} [includeStyleClass=true]
 * @property {import('react').CSSProperties} [style]
 * @property {ButtonOption} [options]
 */
/** @type {import('~/types/React').ReactFC<import('~/contentstack/types').ModelWithLivePreviewAttr<LinkButtonOptions>>} */
const LinkButton = ({ options, children, className, includeStyleClass = true, isLoading = false, style }) => {
	let opt = options;
	if (!opt) {
		return null;
	} else if (Array.isArray(opt)) {
		opt = opt[0];
	}

	return (
		<Link
			id={opt.button_id}
			className={classNames(
				'link-button btn btn--base',
				{
					[`btn--${opt.button_style ?? 'primary'}`]: includeStyleClass,
					italic: opt.button_features?.includes('italic'),
					upper: opt.button_features?.includes('upper'),
					'full-width': opt.button_features?.includes('full-width'),
				},
				className
			)}
			to={opt.button_link}
			openInNewTab={opt.open_in_new_tab}
			style={style}
			{...opt.$?.button_link}
		>
			{isLoading && <MiniSpinner className="link-button-spinner" />}

			{children ?? opt.button_text}

			{opt.button_features?.includes('arrow') && <span className="icon arrow-icon">arrow_forward</span>}
		</Link>
	);
};

export default LinkButton;
